module.exports = __webpack_public_path__ + "img/item-1-2.fe9082cf.png";